if (typeof BSS_B2B !== 'undefined' && BSS_B2B) {
    window.addEventListener("cart_changed", () => {
        setTimeout(() => {
            let storeData = JSON.parse($("#bss-b2b-store-data").html());
            BSS_B2B.makeChangesAfterClickAjaxCart(500)
            BSS_B2B.cart.fixer(storeData, null, false);
            BSS_B2B.handleCartCheckoutBtn(storeData);
        }, 500);
    });
    setTimeout(() => {
        const targetMiniCart = document.querySelector(".halo-cart-sidebar");
        if (targetMiniCart) {
            const mutationObserver = new MutationObserver((recordList, observe) => { // BSS_B2B.makeChangesAfterClickAjaxCart(500)
                BSS_B2B.cart.fixer(JSON.parse(document.getElementById("bss-b2b-store-data").innerHTML), false, false);
                setTimeout(() => {
                    BSS_B2B.handleCartCheckoutBtn(JSON.parse($("#bss-b2b-store-data").html()));
                }, 1000)
            });
            mutationObserver.observe(targetMiniCart, {attributes: true});
        }
    }, 500)

    setTimeout(() => {
        function handleButtonClick(e) {
            e.preventDefault();
            const $button = $(this);
            let oldText = $(this).text();
            $button.css({'pointer-events': 'none', 'opacity': '0.6'});
            $button.text("Loading ...");
            setTimeout(() => {
                $button.css({'pointer-events': 'unset', 'opacity': '1'})
                $button.text(oldText);
            }, 2000);
        }
        $(document).on('click dblclick', 'button[name="checkout"]', handleButtonClick);
    }, 500)
    BSS_B2B.customTriggerCheckoutBtn = function (checkoutBtn) {
        window.location.href = "/checkout";
    }

  const cartButtons = document.querySelectorAll("a.header__icon[data-cart-sidebar]");
cartButtons.forEach(function (cartButton) {
  cartButton.addEventListener("click", function () {
    setTimeout(function () {
      BSS_B2B.cart.fixer(BSS_B2B.shopData, false, true);
      BSS_B2B.handleCartCheckoutBtn(BSS_B2B.shopData);
    }, 2000);
  })
})

const observer = new MutationObserver(function (mutationList, observer) {
  for(mutation of mutationList) {
    if(mutation.type ===  "attributes") {
      if(document.body.classList.contains("cart-sidebar-show")) {
        setTimeout(function () {
          BSS_B2B.cart.fixer(BSS_B2B.shopData, false, true);
          BSS_B2B.handleCartCheckoutBtn(BSS_B2B.shopData);
        }, 1000);
      }
    }
  }
})

observer.observe(document.body, { attributes: true });

  const searchObserver = new MutationObserver(function (mutationList, observer) {
    for(mutation of mutationList) {
      if(mutation.type === "attributes") {
        setTimeout(function () {
          BSS_B2B.cp.changeProductPrice(BSS_B2B.shopData, false, false);
        }, 1000)
      }
    }
  })
  
  searchObserver.observe(document.querySelector("predictive-search"), {attributes: true});

setTimeout(() => {
    const observer = new MutationObserver((MutationList) => {
        for (let item of MutationList) {
            if (item.target.classList.contains('halo-popup-content')) {
                BSS_B2B.cp.changeProductPrice(BSS_B2B.shopData, false, false, false);
            }
            if (item.target.className === "productView-price no-js-hidden clearfix") {
                BSS_B2B.cp.changeProductPrice(BSS_B2B.shopData, false, false, false);
                handlePriceQuickView();
                const quantityButtons = document.querySelectorAll(".halo-productView-right .btn-quantity");
                quantityButtons.forEach((button) =>{
                    button.addEventListener("click", (e) =>{
                       handlePriceQuickView();
                    });
                });
            }
           if (item.target.classList.contains('toggle-content')) {
                BSS_B2B.cp.changeProductPrice(BSS_B2B.shopData, false, false, false);
                setTimeout(() =>{
                   handlePricePDP();
                }, 2000);
            }
        }
    })
    observer.observe(document.body, {
        childList: true,
        subtree: true
    })
}, 300)

document.addEventListener('DOMContentLoaded', function () {
  setTimeout(()=>{
    BSS_B2B.cp.changeProductPrice(BSS_B2B.shopData, false, false, false);
  },3000)
});


    function handlePriceQuickView() {
        if (document.querySelector(".productView-price .bsscommerce-ltsp-message")) return;
        let priceElement = document.querySelector(".productView-price[bss-b2b-product-price]");
        if (!priceElement) return;
        let price = priceElement.textContent.trim();
        price = price.replace(/[^\d]/g, "");
        let quantityElement = document.querySelector("quantity-quick-view-input .quantity__input");
        if (!quantityElement) return;
        const qty = parseInt(quantityElement.value, 10) || 0;
        const subtotal = qty * parseFloat(price);
        let subtotalElement = document.querySelector(".halo-quickView .productView-subtotal .money-subtotal");
        if (subtotalElement) {
            subtotalElement.textContent = BSS_B2B.formatMoney(subtotal * 100);
            subtotalElement.style.opacity = "1";
        }
    }

    function handlePricePDP() {
        if (document.querySelector(".productView-price .bsscommerce-ltsp-message")) return;
        let priceElement = document.querySelector(".productView-price span[bss-b2b-product-price]");
        if (!priceElement) return;
        const nestedPriceElement = priceElement.querySelector("span[bss-b2b-product-price]");
        if (nestedPriceElement) {
            priceElement = nestedPriceElement;
        }
        let price = priceElement.textContent.trim();
        price = price.replace(/[^\d]/g, "");
        let quantityElement = document.querySelector(".quantity__input");
        if (!quantityElement) return;
        const qty = parseInt(quantityElement.value, 10) || 0;
        const subtotal = qty * parseFloat(price);
        let subtotalElement = document.querySelector(".productView-subtotal .money-subtotal");
        if (subtotalElement) {
            subtotalElement.textContent = BSS_B2B.formatMoney(subtotal * 100);
            subtotalElement.style.opacity = "1";
        }
    }

document.addEventListener('DOMContentLoaded', (e) =>{
    setTimeout(() =>{
        handlePricePDP();
    },
    3000);
    const quantityButtons = document.querySelectorAll(".halo-productView-right .btn-quantity");
    quantityButtons.forEach((button) =>{
        button.addEventListener("click", (e) =>{
            handlePricePDP();
        });
    });
});

}

